/** The Conversation Quality page's tabs, kept in `?tab=`; the first is the default. */
export const QUALITY_PAGE_TABS = ["overview", "learning", "handovers", "volume"] as const

export type QualityPageTab = (typeof QUALITY_PAGE_TABS)[number]

/** Former ids that links already sent still carry — the weekly digest linked `fix` before the tab was renamed. */
const TAB_ALIASES: Record<string, QualityPageTab> = { fix: "learning" }

/** A missing or unknown value opens the default tab rather than an empty page. */
export function parseQualityPageTab(value: string | null): QualityPageTab {
  const tab = value !== null && Object.hasOwn(TAB_ALIASES, value) ? TAB_ALIASES[value] : value
  return QUALITY_PAGE_TABS.find((known) => known === tab) ?? QUALITY_PAGE_TABS[0]
}

/** Where a link lands inside the tab it opens, kept in the URL until the tab has got there. */
export interface QualityTabLanding {
  /** A Missed replies cause on Volume, its row opened. */
  missed?: string;
  /** A section of Learning & improvements. */
  section?: "changes" | "questions";
  /** A change waiting in «Needs your decision», by its id. */
  suggestion?: string;
}

export const QUALITY_TAB_LANDINGS = [
  "missed",
  "section",
  "suggestion",
] as const satisfies readonly (keyof QualityTabLanding)[]

/** The page for one weekly report's week, a tab of it, and where in it to land. */
export function qualityPageHref(link: {
  tab: QualityPageTab;
  week?: string;
  agentId?: string;
  landing?: QualityTabLanding;
}): string {
  const params = new URLSearchParams({ page: "conversation-quality", tab: link.tab })
  if (link.week) params.set("week", link.week)
  if (link.agentId) params.set("agentId", link.agentId)
  for (const param of QUALITY_TAB_LANDINGS) {
    const value = link.landing?.[param]
    if (value) params.set(param, value)
  }
  return `?${params.toString()}`
}
